import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import "./Newproducts.css"
import {Data} from "../Data"
import useAuth from '../../hooks/useAuth'

function FlashCards(props){
  
  // const[item,setItem]=useState(Data)
  const{state:{product2}, dispatch}=useAuth()
  const{count,setCount}=useAuth()

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      // speed: 4000,
      // autoplaySpeed: 4000,
      // cssEase: "linear",
     
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    return (
      <>
      <div className="text-dark  mx-3">
     
    
        <Slider {...settings} className="mx-3">
        {product2.map((value,index)=>{
         return  (
          <>
          <div className='box product mx-2' key={index}>
         <div className='img'>
           <img src={value.img} alt='' width='100%' />
         </div>
         <h4 className="fw-bold">{value.name}</h4>
        <div className="d-flex"> <div className="price"><span>${value.price}</span></div>
      
        {count.includes(value) ? (
             <div onClick={() => setCount(count.filter((e)=> e.id !== value.id))} id="remove" className="minus ms-auto me-1 mb-2 ">
            +</div>
                
            ) : (
              <div className="ms-auto me-1 add mb-2" onClick={()=>{setCount([value,...count])}}>+</div>
               
            ) }
        </div>
       </div>
          </>
         )
        })}
        </Slider>
      </div>
      </>
    );
  }
 export default FlashCards
